import { useWriteContract } from "wagmi";
import { PRESALE_CONTRACT_ADDRESS } from "../../../constants";
import { presaleAbi } from "../../../abis/presaleAbi";
import { toast } from "react-toastify";
import { handleWriteContractError } from "../../../helpers";
export function useBuyWithUSDT() {
  const { data, error, writeContractAsync, isPending, isSuccess } =
    useWriteContract();

  const buyWithUSDT = async ({
    presaleId,
    amountOfTokensToBuy,
    referrer,
  }: {
    presaleId: bigint;
    amountOfTokensToBuy: bigint;
    referrer: `0x${string}`;
  }) => {
    try {
      return await writeContractAsync({
        address: PRESALE_CONTRACT_ADDRESS,
        abi: presaleAbi,
        functionName: "buyWithUSDT",
        args: [presaleId, amountOfTokensToBuy, referrer],
      }).then(() => toast.success("Transaction successfully submitted"));
    } catch (error) {
      return null;
    }
  };

  if (error) {
    return handleWriteContractError(error);
  }

  if (!data && !buyWithUSDT) return null;

  return {buyWithUSDTHash:data, buyWithUSDT, error, isPending, isSuccess };
}
